import React from 'react';

import { Box, Flex, Heading, Image, Link, Paragraph } from '@rover/kibble/core';
import { useApiMeSummaryRetrieve } from '@rover/rsdk/src/apiClient/latest/api-me-summary-retrieve';

import getQueryError from '../../../utils/getQueryError';

import FullPageLoading from './FullPageLoading';
import { TrainerApplicationResetButton } from './TrainerApplicationResetButton';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const dogBowl = require('@rover/react-lib/src/images/grooming/doodle-waterbowl.png');

const NotEligibleForTraining: React.FC = () => {
  const { data: meData, isLoading: isMeLoading, error: meError } = useApiMeSummaryRetrieve();

  if (meError) {
    throw getQueryError(meError);
  }

  if (isMeLoading) {
    return <FullPageLoading />;
  }

  return (
    <Flex flexDirection="column" alignItems="center" marginTop={['10x', '16x']}>
      <Flex flexDirection="column" alignItems="center" marginX="3x">
        <Image src={dogBowl} description="Image of a waterbowl" height="96" width="96" />
        <Flex flexDirection="column" gap="2x" marginTop="4x">
          <Heading fontWeight="semibold" size="400" marginBottom="0x">
            Thanks for your interest in Rover Dog Training
          </Heading>
          <Paragraph marginBottom="0x">
            Dog training program is for qualified trainers in certain locations. We will notify you
            as our service expands to your area.
          </Paragraph>
          <Paragraph fontWeight="semibold" paddingTop="4x">
            If you feel you qualify to be listed as a Rover trainer,{' '}
            <Link href="https://support.rover.com/hc/en-us/" target="_blank">
              visit our help center
            </Link>{' '}
            to chat with Rover Support.
          </Paragraph>
        </Flex>
        <Box width="100%" marginTop={['10x', '20x']}>
          <TrainerApplicationResetButton
            variant="primary"
            services={meData.services}
            providerState={meData.providerProfile?.providerState || ''}
          />
        </Box>
      </Flex>
    </Flex>
  );
};

export default NotEligibleForTraining;
